import { LANGUAGES_SUPPORTED, LanguagesSupported, STATUS } from '@/types/enums';
import { LanguageInfo } from '@/types/language';
import { Route } from '@/types/routes';
import { PaginationState } from '@tanstack/react-table';
import { enUS, vi } from 'date-fns/locale';

// #region Routes
enum RoutesKey {
    home,
    login,
    button,
    calendar,
    pagination,
    table,
    reactToastify,
    modal,
    tabs,
    userManagement,
    fileUpload,
    companyManager,
    privacyPolicy,
    fileManagment
}

export const ROUTES: Record<keyof typeof RoutesKey, Route> = {
    home: {
        href: '/',
        title: 'words_title.home',
        menuLabel: 'words_title.home',
        breadcrumbLabel: 'words_title.home'
    },
    login: {
        href: '/login',
        menuLabel: ''
    },
    privacyPolicy: {
        href: '/privacy-policy',
        menuLabel: ''
    },
    button: {
        href: '/button',
        title: 'Button',
        menuLabel: 'Button',
        breadcrumbLabel: 'Button'
    },
    calendar: {
        href: '/calendar',
        title: 'Calendar',
        menuLabel: 'Calendar',
        breadcrumbLabel: 'Calendar'
    },
    pagination: {
        href: '/pagination',
        title: 'Pagination',
        menuLabel: 'Pagination',
        breadcrumbLabel: 'Pagination'
    },
    table: {
        href: '/table',
        title: 'Table',
        menuLabel: 'Table',
        breadcrumbLabel: 'Table'
    },
    reactToastify: {
        href: '/react-toastify',
        title: 'React Toastify',
        menuLabel: 'React Toastify',
        breadcrumbLabel: 'React Toastify'
    },
    modal: {
        href: '/modal',
        title: 'Modal',
        menuLabel: 'Modal',
        breadcrumbLabel: 'Modal'
    },
    tabs: {
        href: '/tabs',
        title: 'Tabs',
        menuLabel: 'Tabs',
        breadcrumbLabel: 'Tabs'
    },
    userManagement: {
        href: '/users',
        title: 'words_title.customerManager',
        menuLabel: 'words_title.customerManager',
        breadcrumbLabel: 'words_title.customerManager'
    },
    fileUpload: {
        href: '/files-upload',
        title: 'words_title.fileUpload',
        menuLabel: 'words_title.fileUpload',
        breadcrumbLabel: 'words_title.fileUpload'
    },
    companyManager: {
        href: '/companies',
        title: 'words_title.companyManager',
        menuLabel: 'words_title.companyManager',
        breadcrumbLabel: 'words_title.companyManager'
    },
    fileManagment: {
        href: '/file-management',
        title: 'words_title.fileManagement',
        menuLabel: 'words_title.fileManagement',
        breadcrumbLabel: 'words_title.fileManagement'
    }
};

// #endregion Routes

// #region Languages
export const DEFAULT_LANGUAGE: LanguagesSupported = LANGUAGES_SUPPORTED.English;

export const LANGUAGES_MAPPER: {
    english: LanguageInfo,
    vietnamese: LanguageInfo
} = {
    english: {
        code: LANGUAGES_SUPPORTED.English,
        fullname: 'words_title.english',
        shortName: 'EN',
        flag: 'gb',
        dateFns: enUS
    },
    vietnamese: {
        code: LANGUAGES_SUPPORTED.Vietnamese,
        fullname: 'words_title.vietnamese',
        shortName: 'VI',
        flag: 'vn',
        dateFns: vi
    }
};

// #endredion

// #region Dates

export const DATE_YMD = 'yyyy/MM/dd';
export const DATE_TIME = 'yyyy/MM/dd HH:mm:ss';

// #endregion

// #region Table

export const DEFAULT_SELECT_PAGE_SIZES: number[] = [
    10, 20, 50, 100, 200, 500, 1000
];

export const DEFAULT_PAGINATION: PaginationState = {
    pageIndex: 0,
    pageSize: 10
};

// #endregion

// #region number
export const MAX_LENGTH_DEFAULT_INPUT = 255;

// #endregion

// #region User
export const USER_STATUS = {
    active: {
        label: '有効',
        value: STATUS.Active
    },
    inactive: {
        label: '無効',
        value: STATUS.Inactive
    }
};
// #endregion

export const PRE_FIX_URL_FOLDER_DRIVE = 'https://drive.google.com/drive/folders/';

export const ACTIVE = 1;
export const INACTIVE = 0;
export const DELETE = 1;
export const NOT_DELETE = 0;

export const keyStorage = {
    TOKEN: 'token',
    PROFILE: 'profile',
    AVATAR: 'avatar',
    STATE: 'state',
    ACCESS_TOKEN_GOOGLE: 'accessTokenGG'
};
